import { releasePushDevice } from './nativeNotifications';

export const getTokenFromLocalStorage = () => {
  const tokenLocal = localStorage.getItem('token');
  const token = tokenLocal && JSON.parse(tokenLocal);

  if (token) {
    return token?.token;
  } else {
    return '';
  }
};

export const setTokenToLocalStorage = (token) => {
  try {
    const tokenString = JSON.stringify({ token });
    localStorage.setItem('token', tokenString);
  } catch (error) {
    console.error('Error:', error);
  }
};

//Clear Token local
export const clearTokenFromLocalStorage = () => {
  releasePushDevice();
  localStorage.removeItem('token');
};

// Lưu thông tin user vào localStorage
export const setUserToLocalStorage = (user) => {
  try {
    const userString = JSON.stringify(user);
    localStorage.setItem('user', userString);
  } catch (error) {
    console.error('Error saving user:', error);
  }
};

// Lấy thông tin user từ localStorage
export const getUserFromLocalStorage = () => {
  try {
    const userLocal = localStorage.getItem('user');
    return userLocal ? JSON.parse(userLocal) : null;
  } catch (error) {
    console.error('Error getting user:', error);
    return null;
  }
};

// Xóa thông tin user khỏi localStorage
export const clearUserFromLocalStorage = () => {
  localStorage.removeItem('user');
};

// Xóa tất cả thông tin auth khỏi localStorage
export const clearAllAuthData = () => {
  clearTokenFromLocalStorage();
  clearUserFromLocalStorage();
};
